import React from 'react';
import BackButton from '../_Shared/BackButton';




function ReconditioningTurnaroundTime() {
    return (
        <div className="container">
            <div className="jumbotron">
                <div className="col-sm-10 mx-auto">
                    <BackButton /><h2 className="text-center">Reconditioning Turnaround Time</h2>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="card text-white rounded formula-definition">
                                <div className="card-header text-center" id="formula">Formula Definition : N/A
                                    <br />
                                    Guide : 3 Days
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}




export {
    ReconditioningTurnaroundTime
}